const config = {
  websocket: 'wss://tstest.dw3.it/ws'
};

export default config;